<template>
    <div :class="b()">
        <div class="timeline timeline-inverse">
            <template v-for="(histories, key) in this.history">
                <div class="time-label">
                    <span class="bg-success">
                      {{ key }}
                    </span>
                </div>
                <template v-for="(item, key) in histories">
                    <div v-show="historyActionVisible(item)">
                        <i :class="getIconClass(item.actionName)"></i>
                        <div class="timeline-item">
                            <span class="time"><i class="far fa-clock"></i> {{ item.createdAsRelativeTime }}</span>
                            <h3 class="timeline-header">
                                <a :href="userLink(item.userIdAction.id)">{{ item.userIdAction.name }}</a> - {{ item.actionDesc }}
                            </h3>

                            <!-- Смена ответственного -->
                            <template v-if="item.actionName === 'change_account_user'">
                                <div class="timeline-body" v-if="item.options.accountManager.name">
                                    Новый ответственный - <a :href="userLink(item.options.accountManager.id)">{{ item.options.accountManager.name }}</a>
                                </div>
                                <div class="timeline-body" v-else>
                                    Ответственный удален
                                </div>
                            </template>

                            <!-- Новый комментарий -->
                            <template v-if="item.actionName === 'add_comment'">
                                <div class="timeline-body">
                                    <pre>{{ item.options.commentText }}</pre>
                                    <template v-if="item.permissions.isEditDelete">
                                        <div class="timeline-footer">
                                            <button
                                                type="button"
                                                class="btn btn-primary btn-sm"
                                                @click="modalEditComment(item.actionId, item.options.commentText)">
                                                Изменить
                                            </button>
                                            <button @click="deleteHistory(item.actionId)" type="button" class="btn btn-danger btn-sm">Удалить</button>
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <!-- Смена статуса -->
                            <template v-if="item.actionName === 'change_status'">
                                <div class="timeline-body">
                                    {{ item.options.status }}
                                </div>
                            </template>

                            <!-- Дата регистрации -->
                            <template v-if="item.actionName === 'date_reg'">
                                <div class="timeline-body">
                                    Когда пользователь зарегистрировался на площадке
                                </div>
                            </template>

                            <!-- Смена роли -->
                            <template v-if="item.actionName === 'change_user_role'">
                                <div class="timeline-body" v-if="item.options.role">
                                    Смена роли на - <strong>{{ item.options.role }}</strong>
                                </div>
                                <div class="timeline-body" v-else>
                                    Роль удалена
                                </div>
                            </template>

                            <!-- Загрузка счета -->
                            <template v-if="item.actionName === 'upload_score'">
                                <div class="timeline-body" v-if="item.options.path">
                                    Счёт загружен - <a :href="item.options.path" target="_blank">Открыть</a>
                                </div>
                                <div class="timeline-body removed" v-else>
                                    Счёт удален
                                </div>
                            </template>

                        </div>
                    </div>
                </template>
            </template>

            <div>
                <i class="far fa-user bg-gray"></i>
            </div>
        </div>

        <!--Окно редактирования комменатрия-->
        <div class="modal fade bd-example-modal-lg" id="modalCommentEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Редактирование комментария</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <textarea
                                v-model="historyCommentTextEdit"
                                class="form-control"
                                rows="5"
                                placeholder="Введите комментарий к закупке.."></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="editComment()" type="button" class="btn btn-primary">Отправить</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    const COMPONENT_NAME = 'history-entity';

    import CrmService from '../../services/CrmService';

    export default {
        name: COMPONENT_NAME,
        props: [
            'history',
            'historyParams',
            'createAsDate',
            'createDateAsRelativeTime',
        ],
        data() {
            return {
                actionData: {},
                historyActionId: null,
                historyCommentTextEdit: null,
            }
        },
        methods: {

            // Проверяем выводить ли действие из истории для данной сущности
            historyActionVisible(action) {
                return this.historyParams.hasOwnProperty(action.actionName) ? true : false;
            },

            // Получить класс иконки действия
            getIconClass(actionName) {
                return this.historyParams[actionName].iconClass;
            },

            // Ссылка на профиль пользователя
            userLink(id) {
                return this.$parent.userLink(id);
            },

            // Удалить историю
            async deleteHistory(actionId) {
                if (!confirm('Вы подтверждаете удаление?')) return;

                let response = await CrmService.deleteHistoryEntity(actionId);
                if (response) {
                    this.$message('Успешное удаление!');
                    this.$parent.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Открыть окно редактирования комментария
            modalEditComment(actionId, commentText)
            {
                this.historyActionId = actionId;
                this.historyCommentTextEdit = commentText;
                $('#modalCommentEdit').modal('show');
            },

            // Отредактировать комментарий
            async editComment()
            {
                // Если нет коммента
                if(!this.historyCommentTextEdit) {
                    alert('Введите комментарий');
                    return;
                }

                this.actionData['commentText'] = this.historyCommentTextEdit;

                let response = await CrmService.editHistoryComment(this.historyActionId, this.actionData);
                if (response) {
                    this.$message('Успешное выполнение');
                    this.historyActionId = null;
                    this.historyCommentTextEdit = null;
                    this.actionData = {};
                    $('#modalCommentEdit').modal('hide');
                    this.$parent.updateComponent();
                }else{
                    this.$message('Произошла ошибка');
                }
            },


        },
    }
</script>

<style lang="scss" scoped>
    .history-entity {
        pre {
            padding: 0;
            font-family: "Source Sans Pro",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
            font-size: 16px;
            white-space: pre-line;
        }

        .timeline-body.removed {
            opacity: 0.6;
            background: #ffacac61;
        }
    }
</style>